import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';
import { IntegrationMercadoSharedModule } from '../configuracoes/integration/mercado';
import { MercadoRoutingModule } from './mercado-routing.module';
import { MercadoSituacaoModule } from './situacao';

import { MercadoComponent } from './mercado.component';
import { MercadoFormComponent} from './form';

@NgModule({
    imports: [
        SharedModule,
        MercadoRoutingModule,
        IntegrationMercadoSharedModule,
        MercadoSituacaoModule
    ],
    declarations: [
        MercadoComponent,
        MercadoFormComponent
    ]
})
export class MercadoModule { }
